import { render, staticRenderFns } from "./DetailEwaCompany.vue?vue&type=template&id=f9f93ae4&scoped=true"
import script from "./DetailEwaCompany.vue?vue&type=script&lang=js"
export * from "./DetailEwaCompany.vue?vue&type=script&lang=js"
import style0 from "./DetailEwaCompany.vue?vue&type=style&index=0&id=f9f93ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f93ae4",
  null
  
)

export default component.exports